import React from "react";
import { Facebook } from "react-content-loader";

const ContentLoader = () => {
  // return <Facebook speed={2} />;
  return null;
};

export default ContentLoader;
